import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
const HeartRGB: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 48 48"
    {...props}
  >
    <style>{'.st1{fill:#002677}'}</style>
    <g id="Layer_1">
      <path
        d="M40.5339 10.0706C36.5881 6.1249 30.1907 6.1249 26.245 10.0706L9.71094 26.6046L23.9954 40.8891L23.9998 40.8846L24.0041 40.8891L40.5338 24.3595C44.4797 20.4136 44.4797 14.0163 40.5339 10.0706Z"
        fill="#FF612B"
      />
      <path
        d="M21.7546 10.0706C17.8089 6.1249 11.4116 6.1249 7.4657 10.0706C3.5199 14.0163 3.5199 20.4136 7.4657 24.3595L9.7109 26.6046L23.9998 12.3157L21.7546 10.0706Z"
        fill="#002677"
      />
    </g>
  </Box>
)
export default HeartRGB
